<template>
    <div class="modal-container">
        <header class="modal-header">
            {{ title }}
            <p v-if="subTitle">{{ subTitle }}</p>
        </header>
        <section class="modal-body">
            <slot name="body" />
        </section>
        <footer class="modal-footer"><slot name="footer" /></footer>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';
import _ from 'lodash';

export default {
    name: 'LsModal',
    props: {
        trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
        title: VueTypes.string.isRequired,
        subTitle: VueTypes.sting,
    },
    mounted() {
        this.track({ open: true });
    },
    beforeDestroy() {
        this.track({ open: false });
    },
    methods: {
        track({ open }) {
            const referrerBasePath = `${location.protocol}//${location.host}${this.$route.path}`;
            const kebabModalName = _.kebabCase(this.trackId);
            const modalPath = `${this.$route.path}/modal/${kebabModalName}`;
            const modalUrl = `${referrerBasePath}/modal/${kebabModalName}`;

            lsTrackingService.page({
                data: {
                    path: open ? modalPath : this.$route.path,
                    url: open ? modalUrl : referrerBasePath,
                    referrer: open ? referrerBasePath : modalUrl,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
